let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7I5Jc")).then(() => parcelRequire('1uCPK'));